import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'TopContact',
  setup(__props) {

/**
 * トップページのお問い合わせ導線。
 *
 * Top.vue（1,700行超）の分解で切り出した表示専用ブロック。状態も手続きも持たない。
 *
 * ⚠️ このコンポーネントは静的トップ（public/top-content.html）にも焼かれる。
 * ビルド時に scripts/extract-top-static.js が Top.vue の <top-contact /> を
 * この <template> で置き換えるので、動的な値（API 取得結果・ログイン状態）を
 * 足すときは Top.vue 側で <!-- static:skip --> に入れること。
 *
 * style の .renew3_top 前置きは残す。親 Top.vue の <main class="renew3_top"> を
 * 祖先に持つ前提のセレクタで、静的CSS生成でも同じ形が要る。
 */

return { __sfc: true, }
}

})